import { FC, ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';

export type StatusBadgeVariant = 'error' | 'warning' | 'success';

const variantColors: Record<StatusBadgeVariant, { color: string; backgroundColor: string }> = {
	error: { color: ColorPalette.violetRed, backgroundColor: ColorPalette.lavenderBlush },
	warning: { color: ColorPalette.fuelYellow, backgroundColor: ColorPalette.offYellow },
	success: { color: ColorPalette.jungleGreen, backgroundColor: ColorPalette.narvik },
};

type Props = {
	variant: StatusBadgeVariant;
	children: ReactNode;
	sx?: SxProps;
};

export const StatusBadge: FC<Props> = ({ variant, children, sx }) => {
	return (
		<Box
			component={'span'}
			sx={{
				display: 'inline-block',
				padding: '8px 20px',
				borderRadius: '25px',
				fontSize: '14px',
				fontWeight: 600,
				lineHeight: '18px',
				...variantColors[variant],
				...sx,
			}}
		>
			{children}
		</Box>
	);
};
